import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attack_in",
  "use": "attack_in-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 10\" id=\"attack_in\"><g fill-rule=\"nonzero\"><path d=\"M6 2.11h2v4.8H6zM15.6 2.11H9v4.8h6.6a2.39 2.39 0 002.4-2.4 2.39 2.39 0 00-2.4-2.4zM0 2.01h5v1H0zM0 4.01h5v1H0zM0 6.01h5v1H0zM5 .01h7v1H5zM5 8.01h7v1H5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id